import { utils, writeFileXLSX } from 'xlsx';
import Mapper from './mapper';
import { columns } from '../dtos/columns';

interface ExportProps<T> {
  dataSource: T[];
  fileName: string;
  headers: string[][];
}

export function exportExcel<T>(resultadosTabla: T[], columnas: columns<T>[], nombreArchivo: string) {
  let headers = [columnas.filter((column) => column.export && column.selector).map((column) => column.name)];
  let columnSelector = columnas.filter((column) => column.export && column.selector).map((column) => column.selector);

  const data = resultadosTabla.map(
      (row: T) => {
          let newRow = {};
          columnSelector.forEach((selector, index) => {
              newRow = { ...newRow, [`p${index.toString()}`]: selector!(row) };
          });
          return newRow;
      },
  );

  return Export({
      dataSource: data,
      fileName: Mapper.ToNombreArchivoExport(nombreArchivo),
      headers: headers as string[][],
  });
}

export default function Export<T>({ dataSource, fileName, headers }: ExportProps<T>) {
  const ws = utils.book_new();
  utils.sheet_add_aoa(ws, headers);
  const worksheet = utils.sheet_add_json(ws, dataSource, {
    origin: 'A2',
    skipHeader: true,
  });
  utils.book_append_sheet(ws, worksheet, "Hoja 1");

  writeFileXLSX(ws,  `${fileName}.xlsx`, { compression: true });
}
